<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import gateway from './services/gateway';

export default {
  beforeCreate() {
    const isGateway = window.location !== window.parent.location;
    if (!isGateway) return;

    gateway.init({
      dispatch: this.$store.dispatch,
    });
  },
};
</script>

<style lang="scss">
@import "scss/themes/themes";
</style>
